// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"footer_footerContainer__19mmv","text":"footer_text__3WN04"};